var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8888_44230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#pattern0_8888_44230)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8888_44230)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#pattern1_8888_44230)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#018D47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_8888_44230",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8888_44230",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_8888_44230",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8888_44230",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8888_44230",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cf5ecaf2804d9a9917d2830860362e02.svg";
export { ForwardRef as ReactComponent };